export default __webpack_public_path__ + "static/umagine_case_study_thumb-e4e0bbf6f2daef6c1cfe38963f93d6e9.png";